/***
 * 公用常量配置
 */
import { marked } from "marked";

export const globalActivityList = [
  { label: "签到赢好礼", value: 1 },
  { label: "浏览礼品有礼", value: 2 },
  { label: "每日限时抢", value: 3 },
  { label: "关注店铺有礼", value: 4 },
  { label: "邀请开卡有礼", value: 5 },
  { label: "邀请关注有礼", value: 6 },
  { label: "完善信息有礼", value: 7 },
  { label: "幸运抽奖", value: 8 },
  { label: "开卡礼包", value: 13 },
  { label: "店铺礼包", value: 14 },
  { label: "店铺礼包（千人千面）", value: 15 },
  { label: "BI店铺礼包", value: 63 },
  { label: "关注礼包", value: 74 },
  { label: "加购礼包", value: 75 },
  { label: "下单有礼", value: 16 },
  { label: "首单专享礼", value: 17 },
  { label: "复购有礼", value: 18 },
  { label: "下单抽奖", value: 19 },
  { label: "评价有礼", value: 20 },
  { label: "裂变神券", value: 21 },
  { label: "天降红包雨", value: 22 },
  { label: "欢乐娃娃机", value: 23 },
  { label: "大家来找茬", value: 24 },
  { label: "预售有礼", value: 27 },
  { label: "预售抽奖", value: 28 },
  { label: "超级裂变券", value: 31 },
  { label: "加购有礼", value: 34 },
  { label: "打榜有礼", value: 36 },
  { label: "生日有礼", value: 39 },
  { label: "晒单有礼", value: 41 },
  { label: "N元锁权", value: 43 },
  { label: "专属赠礼品", value: 40 },
  { label: "会员升级礼", value: 44 },
  { label: "满额有礼", value: 46 },
  { label: "锁权有礼", value: 45 },
  { label: "情书贺卡", value: 50 },
  { label: "调查问卷", value: 47 },
  { label: "定时开奖", value: 48 },
  { label: "0元试用", value: 51 },
  { label: "试用回购礼", value: 52 },
  { label: "购物打卡", value: 53 },
  { label: "集卡有礼", value: 62 },
  { label: "组队瓜分奖品", value: 64 },
  { label: "粉丝打卡", value: 65 },
  { label: "入会有礼", value: 66 },
  { label: "销售打榜", value: 67 },
  { label: "会员成长计划", value: 68 },
  { label: "拼团砍价", value: 69 },
  { label: "趣味游戏", value: 71 },
  { label: "时光许愿池", value: 76 },
  { label: "购物车锦鲤", value: 77 },
  { label: "打包一口价", value: 78 },
  { label: "盖楼有礼", value: 79 },
  { label: "小红书晒单礼", value: 80 },
  { label: "集分冲榜", value: 81 },
  { label: "粉丝集分应援", value: 82 },
  { label: "晒图pk", value: 83 },
  { label: "日历打卡", value: 84 },
  { label: "百变趣答", value: 85 },
  { label: "AI趣味答题", value: 86 },
  { label: "答题导购", value: 87 },
  { label: "积分兑换优惠券", value: 89 },
]

// 积分兑换活动类型
export const exchangeActivityTypes = [
  { label: "兑换实物", value: 9 },
  { label: "兑换优惠券", value: 10 },
  { label: "兑换京豆", value: 29 },
  { label: "兑换E卡", value: 30 },
  { label: "兑换红包", value: 38 },
  { label: "积分加钱购", value: 55 },
  { label: "兑换爱奇艺会员", value: 58 },
  { label: "兑换PLUS会员", value: 59 },
  { label: "兑换礼品卡", value: 60 },
  { label: "兑换百度网盘", value: 61 },
]

export default {
  install(Vue) {
    Vue.prototype.globalActivityList = globalActivityList
    // 根据活动类型获取活动类型名称
    Vue.prototype.$getActivityNameByValue = (value) => {
      const index = globalActivityList.findIndex(item => item.value == value )
      if (index != -1) {
        return globalActivityList[index].label
      } else {
        return ''
      }
    }
    //会员等级
    Vue.prototype.memberUser_all = [
      {
        value: "0",
        label: '店铺会员'
      },
      {
        value: "1",
        label: '普通会员'
      },
      {
        value: "2",
        label: '高级会员'
      },
      {
        value: "3",
        label: 'VIP会员'
      },
      {
        value: "4",
        label: '至尊VIP会员'
      }
    ];
    //性别
    Vue.prototype.sex_all = [
      {
        value: '0',
        label: '未知'
      },
      {
        value: '1',
        label: '男'
      },
      {
        value: '2',
        label: '女'
      },
    ];
    //全局引用，并且或者
    Vue.prototype.sureOr_all = [
      {
          id: 0,
          label: '并且'
      },
      {
          id: 1,
          label: '或者'
       }
     ];
    //职业
    Vue.prototype.worker_all = [
      {
        value: '1',
        label: '学生'
      },
      {
        value: '2',
        label: '白领'
      },
      {
        value: '3',
        label: '公务员'
      }
      ,
      {
        value: '4',
        label: 'IT'
      }
      ,
      {
        value: '5',
        label: '金融族'
      },
      {
        value: '6',
        label: '居家族'
      },
      {
        value: '7',
        label: '医护人员'
      },
      {
        value: '8',
        label: '其他'
      }
    ];
    Vue.prototype.designSpecificationsList = {
      4: require('@/assets/codeForDesign/standardGZDPYL.png'),
      21: require('@/assets/codeForDesign/standardLBSQ.png'),
      6: require('@/assets/codeForDesign/standardYQGZYL.png'),
      27: require('@/assets/codeForDesign/standardYSYL.png'),
      36: "https://cdn-image.yucrm.cn/3dcc9ab306a74820b54cde6c6f96d951.png",
      18: require('@/assets/codeForDesign/standardFGYL.png'),
      19: require('@/assets/codeForDesign/standardXDCJ.png'),
      16: require('@/assets/codeForDesign/standardXDYL.png'),
      17: require('@/assets/codeForDesign/standardSDZXL.png'),
      1: require('@/assets/codeForDesign/standardRLQD.png'),
      34: require('@/assets/codeForDesign/standardJGYL.png'),
      51:require('@/assets/codeForDesign/onTrial.png'),
      28:require('@/assets/codeForDesign/preSaleLottery.png'),
      7:require('@/assets/codeForDesign/perfect.png'),
      20:require('@/assets/codeForDesign/evaluate.png'),
      // 22:require('@/assets/codeForDesign/redEnvelope.png'),
      23:require('@/assets/codeForDesign/moppet.png'),
      // 24:require('@/assets/codeForDesign/findFault.png'),
      5:require('@/assets/codeForDesign/cardActivation.png'),
      // 41:require('@/assets/codeForDesign/review.png'),
      // 44:require('@/assets/codeForDesign/upgrade.png'),
      45:require('@/assets/codeForDesign/IntegralLockRight.png'),
      52:require('@/assets/codeForDesign/trial.png'),
      68: require('@/assets/codeForDesign/userLifecycle-rule.png'),
      69: require('@/assets/codeForDesign/groupBuying.png'),
    }
    Vue.prototype.$parseMarkdownToBlocks = function (md) {
      if (!md) return [];

      // 预处理：如果 ** 的前面一个字符是 %，在 ** 后面添加一个空格
	    let processedMd = md.replace(/(%)(\*\*)/g, '$1$2 ');
	    const lines = processedMd.split("\n");
      const blocks = [];
      let textBuf = []; // 累积的非表格文本行
      let tableLines = []; // 累积的表格行
      let tableConfirmed = false; // 是否已确认是表格（遇到分隔行）

      function flushText() {
        if (textBuf.length > 0) {
          const raw = textBuf.join("\n");
          if (raw.trim()) {
            blocks.push({ type: "markdown", html: marked.parse(raw) });
          }
          textBuf = [];
        }
      }

      function flushTable() {
        if (tableLines.length > 0 && tableConfirmed) {
          const rows = tableLines.map((line) =>
            line
              .split("|")
              .filter((c) => c.trim() !== "")
              .map((c) => c.trim())
          );
          // 跳过分隔行（|---|---|）
          const dataRows = rows.filter(
            (row) => !row.every((cell) => /^[-:]+$/.test(cell))
          );

          // 用 marked 渲染表格 HTML
          const tableMd = tableLines.join("\n");
          blocks.push({
            type: "table",
            html: marked.parse(tableMd),
            rows: dataRows,
          });
        } else if (tableLines.length > 0) {
          // 未确认的表格行当普通文本处理（流式中间态）
          textBuf.push(...tableLines);
        }
        tableLines = [];
        tableConfirmed = false;
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const isTableRow = /^\s*\|/.test(line);
        const isSeparator = /^\s*\|[\s\-:|]+\|\s*$/.test(line);

        if (isTableRow) {
          // 如果之前有普通文本，先 flush
          if (textBuf.length > 0 && tableLines.length === 0) {
            flushText();
          }
          tableLines.push(line);
          if (isSeparator) {
            tableConfirmed = true;
          }
        } else {
          // 非表格行
          if (tableLines.length > 0) {
            flushTable();
          }
          textBuf.push(line);
        }
      }

      // 最后剩余的内容
      if (tableLines.length > 0) flushTable();
      if (textBuf.length > 0) flushText();

      return blocks;
    }
    // 积分兑换活动类型
    Vue.prototype.$getExchangeActivityType = (value)=>{
      const index = exchangeActivityTypes.findIndex(item => item.value == value )
      if (index != -1) {
        return exchangeActivityTypes[index].label
      } else {
        return ''
      }
    };
  }
}